<div class="container pt-5 pb-7 pt-md-6 pb-md-8" *ngIf="contacto">
  <p class="h2">Gracias {{contacto.nombre}},</p>
  <p class="lead">Te llamaremos {{contacto.horaContacto | lowercase}} para explicarte los detalles de un seguro de vida.</p>
</div>